/**
 * root reducer
 * (http://redux.js.org/docs/recipes/reducers/SplittingReducerLogic.html)
 */

import { combineReducers } from 'redux';
import main from './mainReducer';
import lists from './listReducer';

export default combineReducers({
  main,
  lists,
});



// WEBPACK FOOTER //
// ./src/reducers/rootReducer.js